// extracted by mini-css-extract-plugin
export default {"mobilePage":"mobilePage--D8S_n"};